import z from "zod";

export const paginationValidator = z.object({
  pageNumber: z.number().min(1).default(1),
  pageSize: z.number().min(1).optional(),
});

export type PaginationParams = z.infer<typeof paginationValidator>;

// This validator extends the paginationValidator to include an optional search term
export const paginationSearchValidator = paginationValidator.extend({
  searchTerm: z.string().optional(),
});

export type PaginationSearchParams = z.infer<typeof paginationSearchValidator>;
